import { WorkflowState } from "@/types/workflow";

// Empty default — no more auto-loaded E-commerce template. Tour-staging
// provides seeded sandboxes on-demand per onboarding section; blank canvas
// lets users start on their own terms.
export const DEFAULT_WORKFLOW: WorkflowState = {
  name: "",
  blocks: [],
  connectors: [],
  groups: [],
  coordinateOrigin: "center",
};
